import { useParams } from 'react-router-dom';

import { useNavigation } from '@refinedev/core';

import {
  Button,
  Checkbox,
  Loading,
  useSnackbar,
} from '@rrexpress/core';

import { BaseShow } from '@/components/show';
import { DataDisplay } from '@/components/show/data-display';
import useLayout from '@/hooks/useLayout';
import { useModal } from '@/hooks/useModal';
import useBranch from '@/modules/branch/application/branch';
import { IBranch } from '@/modules/branch/model/branch';

const BranchDetail = ({ isTest }: { isTest?: boolean }) => {
  useLayout({ title: 'Cabang' });

  const { list } = useNavigation();
  const modal = useModal();
  const { id } = useParams<{ id: string }>();
  const { show } = useSnackbar();

  const { getBranchById, deleteBranch, loadingDelete } = useBranch();
  const { data, isLoading } = getBranchById(id as string);
  const branch: IBranch = (data?.data || {}) as IBranch;

  async function handleOnDelete(idArg: string, rowVersion: string) {
    try {
      await deleteBranch(idArg, rowVersion);
      show('Berhasil menghapus cabang', 'success');
      modal.close();
      list('branches');
    } catch (error) {
      show('Gagal menghapus cabang', 'success');
    }
  }

  function handleOnDeleteShow() {
    modal.open({
      title: 'Hapus Cabang',
      template: loadingDelete
        ? (
          <Loading
            variant="circular"
            size={40}
            speed={0.6}
            indicatorCap="round"
          />
        )
        : (
          <p className="text-[#222222]">
            Apakah anda yakin akan menghapus <span className="font-medium">{branch.branch_name}</span> dari daftar kontak?
          </p>
        ),
      footer: (
        <div className="flex gap-3">
          <Button variant="text" onClick={() => modal.close()}>Batal</Button>
          <Button backgroundColor="#BE321E" onClick={() => handleOnDelete(branch.branch_id ?? '', branch.row_version ?? '')}>
            Hapus
          </Button>
        </div>
      ),
    });
  }

  return (
    <div className="w-[50vw] m-auto">
      <BaseShow
        title={branch.branch_name}
        isLoading={isLoading}
        resource="branches"
        id={id as string}
        onDelete={handleOnDeleteShow}
      >
        <div className="mb-4">
          <div className="flex flex-col gap-y-3 mb-8">
            <DataDisplay label="Kode Cabang" value={branch.branch_code} />
            <DataDisplay label="Nama Cabang" value={branch.branch_name} />
            <DataDisplay label="No. Telp" value={branch.phone_number} />
            <DataDisplay label="Alamat" value={branch.address_street || '-'} />
            <DataDisplay label="Kota/Kecamatan" value={`${branch.address_subdistrict_name || ''}, ${branch.address_city_name || ''}, ${branch.address_country_name || ''}`} />
            <DataDisplay label="Kelurahan/Kode Pos" value={`${branch?.address_village_name} / ${branch.address_zipcode}`} />
            <Checkbox label="Aktif" checked={branch.is_active || false} />
          </div>
        </div>
      </BaseShow>
    </div>
  );
};

export default BranchDetail;
